import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { CardLaneForm, CardWrapper, CardFromItem } from "../styles/Base";
import AssignTo from "./AssignTo";
import DropdownField from "./DropdownField";
import InputInline from "../../components/InputInline";
import LinkItemPickerV2 from "../../main/component/LinkItemPickerV2";
import { fromJS } from "immutable";
import { formatISO } from "date-fns";

class NewCardForm extends Component {
  static contextType = React.createContext();
  state = {
    title: "",
    estimatedRevenue: "",
    assignees: [],
    isRequiredName: false,
    bucketId: undefined,
    issue: {},
    contact: {},
  };

  updateField = (field, value) => {
    this.setState({ [field]: value });
  };

  getItemData = () => {
    const {
      title,
      bucketId = this.props.laneId,
      assignees,
      estimatedRevenue,
      issue,
      contact,
    } = this.state;
    return {
      start: {
        value: formatISO(new Date()),
      },
      name: { value: title },
      bucketId: { value: bucketId },
      assignees: { value: assignees },
      issue: { value: issue },
      estimatedRevenue: { value: estimatedRevenue },
      contact: { value: contact },
    };
  };

  handleAdd = () => {
    if (!this.state.title.trim()) {
      this.setState({ isRequiredName: true });
      return;
    }
    this.props.onAdd({ itemData: this.getItemData() });
  };

  onChangeAssign = (users) => {
    if (users) {
      const assigneeIds = users.map((item) => item.accountId);
      this.setState({ assignees: assigneeIds });
    }
  };

  handleKeyPress = () => {
    this.props.onAdd({ itemData: this.getItemData() });
  };

  renderSaleForm = () => {
    const { t, buckets, laneId, projectId, isJira = false } = this.props;
    const {
      bucketId = laneId,
      isRequiredName,
      assignees,
      title,
      estimatedRevenue,
      issue,
      contact,
    } = this.state;
    return (
      <CardWrapper>
        <CardFromItem>
          <div className={"flex w-full"}>
            <InputInline
              placeholder={t("e.g Customer trial")}
              onChange={(val) => this.updateField("title", val)}
              autoFocus
              border={true}
              value={title}
              onFinish={this.handleKeyPress}
            />
            {isRequiredName && <div className={"text-red-600 -mr-4"}>*</div>}
          </div>
        </CardFromItem>
        <CardFromItem>
          <InputInline
            placeholder={t("Amount")}
            onChange={(val) => this.updateField("estimatedRevenue", val)}
            value={estimatedRevenue}
            border={true}
            onFinish={this.handleKeyPress}
          />
        </CardFromItem>
        {isJira && (
          <CardFromItem>
            <div className={"w-full"}>
              <LinkItemPickerV2
                placeholder={t("JIRA issue")}
                projectId={projectId}
                items={fromJS(issue)}
                onChange={(issue) => {
                  this.updateField("issue", issue);
                }}
                type={"TASK"}
              />
            </div>
          </CardFromItem>
        )}
        <CardFromItem>
          <div className={"w-full"}>
            <LinkItemPickerV2
              projectId={projectId}
              items={fromJS(contact)}
              placeholder={t("Contact")}
              onChange={(contact) => {
                this.updateField("contact", contact);
              }}
              type={"CONTACT"}
            />
          </div>
        </CardFromItem>
        {!bucketId && (
          <CardFromItem>
            <DropdownField
              value={bucketId}
              options={buckets}
              onChange={(val) => this.updateField("bucketId", val)}
            />
          </CardFromItem>
        )}
        <CardFromItem>
          <AssignTo assigneeIds={assignees} onChange={this.onChangeAssign} />
        </CardFromItem>
      </CardWrapper>
    );
  };

  renderAccountForm = () => {
    const { t, buckets, laneId } = this.props;
    const { bucketId = laneId, isRequiredName, title } = this.state;
    return (
      <CardWrapper>
        <CardFromItem>
          <div className={"flex w-full p-1"}>
            <InputInline
              placeholder={t("e.g ACME")}
              onChange={(val) => this.updateField("title", val)}
              autoFocus
              border={true}
              value={title}
              onFinish={this.handleKeyPress}
            />
            {isRequiredName && <div className={"text-red-600 -mr-4"}>*</div>}
          </div>
        </CardFromItem>
        <CardFromItem>
          <DropdownField
            value={bucketId}
            options={buckets}
            onChange={(val) => this.updateField("bucketId", val)}
          />
        </CardFromItem>
      </CardWrapper>
    );
  };
  renderContactForm = () => {
    const { t, buckets, laneId } = this.props;
    const { bucketId = laneId, isRequiredName, title } = this.state;
    return (
      <CardWrapper>
        <CardFromItem>
          <div className={"flex w-full p-1"}>
            <InputInline
              placeholder={t("e.g Robert V")}
              onChange={(val) => this.updateField("title", val)}
              autoFocus
              border={false}
              value={title}
              onFinish={this.handleKeyPress}
            />
            {isRequiredName && <div className={"text-red-600 -mr-4"}>*</div>}
          </div>
        </CardFromItem>
        <CardFromItem>
          <DropdownField
            value={bucketId}
            options={buckets}
            onChange={(val) => this.updateField("bucketId", val)}
          />
        </CardFromItem>
        <CardFromItem>
          <LinkItemPickerV2
            onChange={() => {}}
            type={"COMPANY"}
            items={fromJS([])}
            projectId={projectId}
          />
        </CardFromItem>
      </CardWrapper>
    );
  };

  renderForm() {
    const { laneType } = this.props;
    if (laneType == "SALE") {
      return this.renderSaleForm();
    }
    if (laneType == "COMPANY") {
      return this.renderAccountForm();
    }
    return this.renderContactForm();
  }

  render() {
    const { t, onCancel } = this.props;
    return (
      <CardLaneForm>
        {this.renderForm()}
        <div className={"flex space-x-2 w-full justify-end p-2 align-middle"}>
          <div onClick={this.handleAdd} className={"text-blue-600 cursor-pointer w-16"}>
            {t("Submit")}
          </div>
          <div onClick={onCancel} className={"text-gray-600 hover:text-blue-600 cursor-pointer"}>
            {t("Close")}
          </div>
        </div>
      </CardLaneForm>
    );
  }
}

NewCardForm.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onAdd: PropTypes.func.isRequired,
  isShowLaneCardForm: PropTypes.bool,
  listLane: PropTypes.array,
  members: PropTypes.any,
  isJira: PropTypes.bool,
};

NewCardForm.defaultProps = {
  isJira: false,
};

const mapStateToProps = (state) => {
  const tenantInfo = state.tenant?.get?.("tenantInfo");
  return {
    isJira: tenantInfo?.getIn?.(["host", "product"]) === "JIRA",
  };
};

export default connect(mapStateToProps)(withTranslation()(NewCardForm));
